import { css } from 'styled-components';
import { imageIcon } from '../../theme/helpers';
import { CloseButtonProps } from './models';

export const CloseButton = css<CloseButtonProps>(({ theme, size }) => {
  return css`
    cursor: pointer;
    ${imageIcon({ icon: 'close', width: size, height: size })};
  `;
});
